// All runtime endpoints. Values fall back to defaults that work against a
// local Function URL + a `terraform output` for Cognito. Override at build
// time with REACT_APP_* env vars.

interface EnvironmentConfig {
  apiBaseUrl: string;             // Lambda Function URL, no trailing slash
  /** Base URL of the lambda-rag-ask Function URL. Frontend POSTs to
   *  `${ragAskUrl}/` with a Bearer id_token to get a Siril-manual-
   *  grounded answer. Empty = the script-explainer modal hides. */
  ragAskUrl: string;
  cognito: {
    domain: string;               // e.g. https://pancakestack-prod-....auth.us-east-1.amazoncognito.com
    clientId: string;             // web client id
    region: string;
    scopes: string[];
  };
  stripe: {
    /** Base URL of the lambda-stripe-topup Function URL. Frontend
     *  posts to `${topupBaseUrl}/checkout`; leave blank to hide topup
     *  UI entirely (also gated by TopupContext.canTopup). */
    topupBaseUrl: string;
    /** Map from TOPUP_PACKS.id → Stripe price ID. Any pack whose id is
     *  missing from this map will render as a disabled card. */
    priceIds: Record<string, string>;
  };
}

const strip = (v: string) => v.replace(/\/+$/, '');

const env = (key: string, fallback: string = ''): string => {
  const v = process.env[key];
  if (!v && !fallback) {
    // eslint-disable-next-line no-console
    console.warn(`[env] missing ${key}`);
  }
  return v || fallback;
};

export const environment: EnvironmentConfig = {
  apiBaseUrl: strip(env('REACT_APP_API_BASE_URL', '')),
  ragAskUrl:  strip(env('REACT_APP_RAG_ASK_URL', '')),
  cognito: {
    domain:   strip(env('REACT_APP_COGNITO_DOMAIN', '')),
    clientId: env('REACT_APP_COGNITO_CLIENT_ID', ''),
    region:   env('REACT_APP_AWS_REGION', 'us-east-1'),
    scopes:   ['openid', 'email', 'profile'],
  },
  stripe: {
    topupBaseUrl: strip(env('REACT_APP_STRIPE_TOPUP_URL', '')),
    priceIds: {
      // Keys must match TOPUP_PACKS ids in services/plan.ts.
      small: env('REACT_APP_STRIPE_PRICE_SMALL', ''),
      bulk:  env('REACT_APP_STRIPE_PRICE_BULK',  ''),
      whale: env('REACT_APP_STRIPE_PRICE_WHALE', ''),
    },
  },
};

export default environment;
